export default __webpack_public_path__ + "static/media/blog-img77.b1c3c5a6.jpg";